import axios from 'axios';

export type ContacReportsConsultoresCsvBaseQuery = {
  dataInicio: string;
  dataFim: string;
  consultores?: string[];
  consultor?: string;
};

/**
 * Executa a chamada e trata o erro de rede. O `axios.get` fica no CALL SITE (dentro
 * de cada função exportada, logo após seu próprio `const url`), não aqui — passar a
 * URL por parâmetro para um helper compartilhado faz o extrator do contrato
 * cross-repo (`scripts/extrair-rotas-consumidas.js`) ambiguar entre as várias
 * declarações `const url` do arquivo e resolver para a errada (`BUG-V92`).
 */
const baixarRelatorio = async (
  chamada: () => Promise<{ data: unknown }>,
  mensagemErroPadrao: string,
): Promise<unknown> => {
  try {
    const response = await chamada();
    return response.data;
  } catch (error: unknown) {
    console.error('❌ Erro ao baixar relatório:', error);

    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || mensagemErroPadrao);
    }
    throw new Error('Erro desconhecido');
  }
};

const dispararDownloadDoBlob = (data: unknown, mimeType: string, filenamePrefix: string, extensao: string) => {
  const blob = new Blob([data as BlobPart], { type: mimeType });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);

  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  link.download = `${filenamePrefix}-${timestamp}.${extensao}`;

  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadRelatorioCsvConsultoresResumo = async (
  query: ContacReportsConsultoresCsvBaseQuery,
) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/contac-reports/consultores/resumo.csv`;

  const params = new URLSearchParams();
  params.append('dataInicio', query.dataInicio);
  params.append('dataFim', query.dataFim);
  query.consultores?.forEach((c) => params.append('consultores', c));
  if (query.consultor) params.append('consultor', query.consultor);

  const data = await baixarRelatorio(
    () => axios.get(`${url}?${params.toString()}`, { withCredentials: true, responseType: 'blob' }),
    'Erro ao gerar relatório CSV',
  );
  dispararDownloadDoBlob(data, 'text/csv; charset=utf-8', 'Contac-Relatorio-Consultores-Resumo', 'csv');
};

export const downloadRelatorioCsvDreConsultor = async (
  query: ContacReportsConsultoresCsvBaseQuery,
) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/contac-reports/consultores-dre/resumo.csv`;

  const params = new URLSearchParams();
  params.append('dataInicio', query.dataInicio);
  params.append('dataFim', query.dataFim);
  query.consultores?.forEach((c) => params.append('consultores', c));
  if (query.consultor) params.append('consultor', query.consultor);

  const data = await baixarRelatorio(
    () => axios.get(`${url}?${params.toString()}`, { withCredentials: true, responseType: 'blob' }),
    'Erro ao gerar relatório CSV',
  );
  dispararDownloadDoBlob(data, 'text/csv; charset=utf-8', 'Contac-Relatorio-DRE-Consultor', 'csv');
};

export const downloadRelatorioXlsxConsultoresResumo = async (
  query: ContacReportsConsultoresCsvBaseQuery,
) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/contac-reports/consultores/resumo.xlsx`;

  const params = new URLSearchParams();
  params.append('dataInicio', query.dataInicio);
  params.append('dataFim', query.dataFim);
  query.consultores?.forEach((c) => params.append('consultores', c));
  if (query.consultor) params.append('consultor', query.consultor);

  const data = await baixarRelatorio(
    () => axios.get(`${url}?${params.toString()}`, { withCredentials: true, responseType: 'blob' }),
    'Erro ao gerar relatório XLSX',
  );
  dispararDownloadDoBlob(
    data,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'Contac-Relatorio-Consultores-Resumo',
    'xlsx',
  );
};

export const downloadRelatorioXlsxDreConsultor = async (
  query: ContacReportsConsultoresCsvBaseQuery,
) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/contac-reports/consultores-dre/resumo.xlsx`;

  const params = new URLSearchParams();
  params.append('dataInicio', query.dataInicio);
  params.append('dataFim', query.dataFim);
  query.consultores?.forEach((c) => params.append('consultores', c));
  if (query.consultor) params.append('consultor', query.consultor);

  const data = await baixarRelatorio(
    () => axios.get(`${url}?${params.toString()}`, { withCredentials: true, responseType: 'blob' }),
    'Erro ao gerar relatório XLSX',
  );
  dispararDownloadDoBlob(
    data,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'Contac-Relatorio-DRE-Consultor',
    'xlsx',
  );
};
